"use client";
import React, { createContext, ReactNode, useEffect, useState } from "react";

interface TrackingContextData {
  referrer: string | null;
  landingUrl: string | null;
  utmSource: string | null;
  utmMedium: string | null;
  utmCampaign: string | null;
  gclid: string | null;
  fbclid: string | null;
}

const TrackingContext = createContext<TrackingContextData>({
  referrer: null,
  landingUrl: null,
  utmSource: null,
  utmMedium: null,
  utmCampaign: null,
  gclid: null,
  fbclid: null,
});

export const TrackingProvider = ({ children }: { children: ReactNode }) => {
  const [trackingData, setTrackingData] = useState<TrackingContextData>({
    referrer: null,
    landingUrl: null,
    utmSource: null,
    utmMedium: null,
    utmCampaign: null,
    gclid: null,
    fbclid: null,
  });

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);

    const storedLandingUrl = localStorage.getItem("landingUrl");
    if (!storedLandingUrl) {
      localStorage.setItem("landingUrl", window.location.href);
    }
    setTrackingData({
      referrer: document.referrer || null,
      landingUrl: storedLandingUrl || window.location.href, // ใช้ค่าใน localStorage ถ้ามี
      utmSource: urlParams.get("utm_source"),
      utmMedium: urlParams.get("utm_medium"),
      utmCampaign: urlParams.get("utm_campaign"),
      gclid: urlParams.get("gclid"),
      fbclid: urlParams.get("fbclid"),
    });
  }, []);

  return (
    <TrackingContext.Provider value={trackingData}>
      {children}
    </TrackingContext.Provider>
  );
};

export default TrackingContext;
